const repeatPrefix = 'repeated_';

export const defaultRepeatName = 'current';

/**
 * Gets the name of the repeat defined by the given component's `repeat` binding object.
 * It correctly strips the `repeated_` prefix if needed, and defaults to `current` if
 * not explicitly named.
 * @param {object} repeatBinding the configuration object for component's `repeat`
 */
// eslint-disable-next-line import/prefer-default-export
export function getRepeatNameFromBinding(repeatBinding, defaultName = defaultRepeatName) {
  if (!repeatBinding) {
    return null; // No repeat
  }
  const { name, alias, as } = repeatBinding;
  if (alias != null) {
    // This is the new property that defines the repeat name without need for `repeated_` prefix.
    return alias;
  }
  if (name != null) {
    // "alias" was briefly called "name" beforehand.
    // This if statement can be removed once the test cases have been updated.
    return name;
  }
  if (!as || as === defaultName) {
    // Fallback to 'current' if not defined
    return defaultName;
  }
  if (as.startsWith(repeatPrefix)) {
    // Strip the 'repeated_' prefix
    return as.slice(repeatPrefix.length);
  }
  // This should not be possible in practice...
  return as;
}
